import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  AJOUTER_PARAMETRE,
  LISTE_PARAMETRE_CONFIG,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";

export const Configuration = () => {
  const param = useConfigStore();
  const [isSubmit, setIsSubmit] = useState(false);
  const [value, setValue] = useState();
  const [values, setValues] = useState({});

  const config = [
    {
      id: 1,
      description: "Nombre d'operation par équipe",
      param: "TOTALE_OPERATION",
      defaultValue: param?.data?.TOTALE_OPERATION,
      message: "Distance de localisation appliquée",
    },
    {
      id: 2,
      description: "Distance PBO (kilomètre)",
      param: "DISTANCE_PBO",
      defaultValue: param?.data?.DISTANCE_PBO,
      message: "Distance PBO appliqué",
    },
    {
      id: 3,
      description: "Afficher le champ SN lors de la livraison(OUI/NON)",
      param: "CHAMPS_SN",
      defaultValue: param?.data?.CHAMPS_SN,
      message: "Configuration SN appliqué",
    },
    {
      id: 4,
      description: "Attribution automatique des rendez-vous en attente",
      param: "ATTRIBUTION_AUTOMATIQUE_RDV",
      defaultValue: param?.data?.ATTRIBUTION_AUTOMATIQUE_RDV,
      message: "Configuration appliqué",
    },
    {
      id: 5,
      description: "Afficher le champ Numéro d'avantage(OUI/NON)",
      param: "CHAMPS_NUMERO_AVANTAGE",
      defaultValue: param?.data?.CHAMPS_NUMERO_AVANTAGE,
      message: "Numéro d'avantage appliqué",
    },
    {
      id: 6,
      description: "Afficher le champ OTP (OUI/NON)",
      param: "CHAMPS_OTP",
      defaultValue: param?.data?.CHAMPS_OTP,
      message: "Configuration OTP appliqué",
    },
  ];

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
  }, []);

  useEffect(() => {
    if (param?.data) {
      setValues({
        TOTALE_OPERATION: param.data?.TOTALE_OPERATION ?? "",
        DISTANCE_PBO: param.data?.DISTANCE_PBO ?? "",
        CHAMPS_SN:
          param.data?.CHAMPS_SN !== undefined && param.data?.CHAMPS_SN !== null
            ? String(param.data.CHAMPS_SN)
            : "",
        ATTRIBUTION_AUTOMATIQUE_RDV:
          param.data?.ATTRIBUTION_AUTOMATIQUE_RDV !== undefined &&
          param.data?.ATTRIBUTION_AUTOMATIQUE_RDV !== null
            ? String(param.data.ATTRIBUTION_AUTOMATIQUE_RDV)
            : "",
        CHAMPS_NUMERO_AVANTAGE:
          param.data?.CHAMPS_NUMERO_AVANTAGE !== undefined &&
          param.data?.CHAMPS_NUMERO_AVANTAGE !== null
            ? String(param.data.CHAMPS_NUMERO_AVANTAGE)
            : "",
        CHAMPS_OTP:
          param.data?.CHAMPS_OTP !== undefined &&
          param.data?.CHAMPS_OTP !== null
            ? String(param.data.CHAMPS_OTP)
            : "",
      });
    }
  }, [param?.data]);

  return (
    <>
      {config.map((item) => (
        <div className="p-3 my-8 border bg-white w-[535px] rounded-xl">
          <div className="lg:flex items-center justify-between gap-4">
            <label className="block mb-2 text-xs  text-gray-900">
              {item.description}
            </label>
            <div className="flex gap-2">
              {item.param === "CHAMPS_SN" ||
              item.param === "ATTRIBUTION_AUTOMATIQUE_RDV" ||
              item.param === "CHAMPS_OTP" ||
              item.param === "CHAMPS_NUMERO_AVANTAGE" ? (
                <select
                  value={values[item.param] ?? ""}
                  onChange={(e) =>
                    setValues((s) => ({ ...s, [item.param]: e.target.value }))
                  }
                  className="w-40 text-center input input-bordered h-10 text-sm font-semibold"
                >
                  <option value="">--Selectionner--</option>
                  <option value={true}>OUI</option>
                  <option value={false}>NON</option>
                </select>
              ) : (
                <input
                  value={values[item.param] ?? item.defaultValue ?? ""}
                  onChange={(e) =>
                    setValues((s) => ({ ...s, [item.param]: e.target.value }))
                  }
                  type="text"
                  className="w-40 text-center input input-bordered h-10 text-sm font-semibold"
                />
              )}

              <button
                type="submit"
                onClick={() => {
                  const valeur = values[item.param] ?? "";
                  setIsSubmit(true);
                  store(`${AJOUTER_PARAMETRE}`, "application/json", {
                    designation: item.param,
                    valeur: valeur,
                  })
                    .then((res) => {
                      if (res.status === 200) {
                        toast.success(item.message);
                        setIsSubmit(false);
                        param.getData(LISTE_PARAMETRE_CONFIG);
                      }
                    })
                    .catch((err) => {
                      setIsSubmit(false);
                      if (err?.response?.data?.donnee) {
                        toast.error(err.response.data.donnee);
                      } else {
                        toast.error("Erreur lors de l'enregistrement");
                      }
                    });
                }}
                disabled={isSubmit ? true : false}
                className={`${
                  !isSubmit
                    ? "text-black bg-main"
                    : "text-slate-800 bg-slate-200 "
                } ml-auto px-3 py-2 rounded-md font-normal text-xs`}
              >
                {!isSubmit ? "Appliquer" : "Veuillez patientez..."}{" "}
                {isSubmit ? (
                  <span className="loading loading-dots loading-xs"></span>
                ) : null}
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
